import { CountryCode } from '~/enums';
import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import Card from '~/components/shared/Card/Card';
import { Typography } from '~/components/shared/Typography/Typography';
import { getSigningMethod } from '~/constants/markets';
import useTranslate from '~/hooks/useTranslate';
import { RootState } from '~/store/types/sharedTypes';
import Stack from '~/components/shared/Layout/Stack';
import Group from '~/components/shared/Layout/Group';
import { theme } from '~/styles/themes';
import { MediaQueries } from '~/constants/constVars';

const ListContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
`;

const IntroductionHeader = styled(Group)``;

const ItemLabelContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const ItemValueContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex-grow: 1;
  padding-left: 1em;
`;

const TrustlyLogo = styled.img`
  width: 4em;
  right: 1em;
  top: 1em;
  position: absolute;

  @media ${MediaQueries.smallScreen} {
    top: 0;
    right: 0;
    position: relative;
  }
`;

const Wrapper = styled.div`
  padding-block: 1.5rem;
`;

const IntroductionCard: React.FC = () => {
  const translate = useTranslate();
  const { market, language } = useSelector((state: RootState) => state.intl);

  const showPaymentInstructions = market === CountryCode.SE;
  const showTrustlyPayment =
    market === CountryCode.NO ||
    market === CountryCode.DK ||
    market === CountryCode.NL;

  return (
    <Card dataTestId="introduction-card">
      <Stack spacing="xs">
        <Group justify="center" align="center">
          <IntroductionHeader>
            <Typography
              fontSize={1}
              color={theme.colors.dark}
              fontWeight={600}
              centerAlign
            >
              {translate('IntroductionCard.Title') as string}
            </Typography>
          </IntroductionHeader>
          {showTrustlyPayment && <TrustlyLogo src="trustly-logo.png" />}
        </Group>
        {showPaymentInstructions && (
          <Wrapper>
            <Typography lineHeight={1.7} fontSize={1}>
              {translate('IntroductionCard.StepsQuestion')}
            </Typography>
          </Wrapper>
        )}
        <ListContainer>
          <ItemLabelContainer>
            <Typography lineHeight={1.7} fontSize={1}>
              1.
            </Typography>
            <Typography lineHeight={1.7} fontSize={1}>
              2.
            </Typography>
            <Typography lineHeight={1.7} fontSize={1}>
              3.
            </Typography>
          </ItemLabelContainer>

          <ItemValueContainer>
            <Typography lineHeight={1.7} fontSize={1}>
              {translate('IntroductionCard.DesiredAmount')}
            </Typography>

            <Typography lineHeight={1.7} fontSize={1}>
              {translate('IntroductionCard.AcceptTerms')}
            </Typography>

            <Typography lineHeight={1.7} fontSize={1}>
              {translate('IntroductionCard.SignTheContract', {
                signingMethod: getSigningMethod(market, language),
              })}
            </Typography>
          </ItemValueContainer>
        </ListContainer>
        {(showPaymentInstructions || showTrustlyPayment) && (
          <Wrapper>
            <Typography lineHeight={1.7} fontSize={0.9}>
              {showTrustlyPayment
                ? translate('IntroductionCard.PaymentTrustly')
                : translate('IntroductionCard.Payment')}
            </Typography>
          </Wrapper>
        )}
      </Stack>
    </Card>
  );
};

export default IntroductionCard;
